/**
 * How a site page moves to another without a reload. `routes.tsx` provides it
 * from the app's router; with nothing provided (the prerender, a test) a
 * `SiteLink` is a plain link.
 */
import { createContext } from 'react';

export const SiteNavContext = createContext<((href: string) => void) | null>(null);
